<template>
  <menu>
    <svg-app @action="menu = true" type="menu" theme="w-5" />
    <nav
      v-if="menu"
      style="height: 100vh"
      @click="menu = false"
      class="top g-center bg-slate-700 bg-opacity-50"
    >
      <ul
        class="w-9/12 sm:w-7/12 md:w-5/12 lg:w-3/12 light font-medium grid-1 p-4 rounded-xl overflow-y-auto text-center"
      >
        <h1 class="my-4">{{ $t("fixed.menu.title") }}</h1>
        <div class="between">
          <svg-app type="user" theme="w-5 text-slate-400" />
          <hr class="w-full border-slate-300 mx-4" />
        </div>
        <li @click="$router.push('/favorite')">
          {{ $t("fixed.menu.favorite") }}
        </li>
        <li @click="$router.push('/orders')">
          {{ $t("fixed.menu.orders") }}
        </li>
        <li v-if="installApp" @click="install()">
          {{ $t("fixed.menu.install") }}
        </li>
        <div class="between mt-4">
          <svg-app type="edit" theme="w-5 text-slate-400" />
          <hr class="w-full border-slate-300 mx-4" />
        </div>
        <h1>{{ $t("fixed.menu.theme") }}</h1>
        <ul dir="ltr" class="between tracking-widest">
          <li
            @click="changeTheme('dark')"
            :class="`text-xs m-auto ${
              dark ? 'border-b-2 border-slate-500' : ''
            }`"
          >
            {{ $t("fixed.menu.dark") }}
          </li>
          <li
            @click="changeTheme()"
            :class="`text-xs m-auto ${
              dark ? '' : 'border-b-2 border-slate-500'
            }`"
          >
            {{ $t("fixed.menu.light") }}
          </li>
        </ul>
        <h1>{{ $t("fixed.menu.language") }}</h1>
        <ul dir="ltr" class="between tracking-widest mb-4">
          <li
            @click="changeLanguage('ar')"
            :class="`text-xs m-auto ${
              language == 'ar' ? 'border-b-2 border-slate-500' : ''
            }`"
          >
            Ar
          </li>
          <li
            @click="changeLanguage('en')"
            :class="`text-xs m-auto ${
              language == 'en' ? 'border-b-2 border-slate-500' : ''
            }`"
          >
            En
          </li>
          <li
            @click="changeLanguage('fr')"
            :class="`text-xs m-auto ${
              language == 'fr' ? 'border-b-2 border-slate-500' : ''
            }`"
          >
            Fr
          </li>
        </ul>
        <a
          href="https://facebook.com/lazirijs"
          target="_blank"
          class="tracking-wider text-center mt-6 text-xs text-slate-500 dark:text-slate-400"
        >
          created by LAZIRI
        </a>
      </ul>
    </nav>
  </menu>
</template>

<script>
import svgApp from "@/components/svgApp.vue";

export default {
  components: { svgApp },
  data() {
    let app = document.querySelector("html");
    return {
      app: app,
      menu: false,
      installApp: false,
      language: app.lang,
      dark: localStorage.dark == "true",
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installApp = e;
    });
    const menu = document.querySelector("#menu");
    if (menu) {
      menu.addEventListener("mouseEnter", alert("mouseEnter"));
    }
  },
  methods: {
    changeTheme(theme) {
      switch (theme) {
        case "dark":
          this.app.classList.add("dark");
          localStorage.dark = true;
          this.dark = true;
          break;

        default:
          this.app.classList.remove("dark");
          localStorage.dark = false;
          this.dark = false;
          break;
      }
    },
    changeLanguage(language) {
      this.app.lang = language;
      this.language = language;
      this.$i18n.locale = language;
      localStorage.language = language;
      this.app.dir = language == "ar" ? "rtl" : "ltr";
    },
    install() {
      if (this.installApp) {
        this.installApp.prompt();
      }
    },
  },
};
</script>
